<template>
  <a-modal
    :width="800"
    :closable="false"
    :visible="visible"
    :cancel-button-props="{ style: { display: 'none' } }"
    @ok="visible = false"
  >
      <div v-html="tenantInfo && tenantInfo.systemDetection">
      </div>
        <div class="detection-btns">
        <a-button-group>
            <a-button type="primary" @click="runDetection('network')">网速检测</a-button>
        </a-button-group>
    </div>
    <a-spin :spinning="loading">
        <div class="detection-content">
            <div v-if="detectionResult" v-html="detectionResult"></div>
            <div v-else>请点击上方按钮开始检测</div>
        </div>
    </a-spin>
  </a-modal>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
export default {
  name: "SystemDetectionModal",
  data() {
    return {
      visible: false,
      loading: false,
      tenantInfo: {},
      detectionType: null,  // 检测类型
      detectionResult: null, // 检测结果
      browserDetectionResult: null,

    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.runAutoDetection();
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
    },
    // 自动执行浏览器和系统检测
    async runAutoDetection() {
      this.loading = true;
      try {
        const browserResult = this.testBrowser();
        const systemResult = this.testSystem();
        this.detectionResult = `${browserResult}<br>${systemResult}`;
      } catch (e) {
        console.error(e);
        this.detectionResult = "自动检测失败";
      }
      this.loading = false;
    },
    //设备检测
    async runDetection(type) {
      this.loading = true
      this.detectionType = type
      if (type === 'network') {
        this.loading = true;
        try {
          const speed = await this.testNetworkSpeed();
          var prompt = '';
          if(parseFloat(speed) < 50){
            prompt = '当前带宽低于50Mbs，请尽量提升网络环境';
          }
          this.detectionResult = `当前下载速度：${speed} Mbps<br>` + prompt;
        } catch (e) {
          console.error(e);
          this.detectionResult = "测速失败，请重试";
        }
        this.loading = false;
      } else if (type === 'browser') {
        this.loading = true;
        const result = this.testBrowser();
        this.detectionResult = result;
        this.loading = false;
      } else if (type === 'system') {
        const result = this.testSystem();
        this.detectionResult = result;
        this.loading = false;
      }
    },
    //网络检测
    testNetworkSpeed() {
      return new Promise((resolve, reject) => {
        const fileSizeInMB = 50; // 测试文件大小，单位MB
        const testFileUrl = `https://qn.aice.org.cn/50m.bin`; // 测试文件URL
        const startTime = Date.now();
        const xhr = new XMLHttpRequest();
        xhr.open('GET', testFileUrl);
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              const duration = (Date.now() - startTime) / 1000; // 秒
              const bitsLoaded = fileSizeInMB * 8 * 1024 * 1024; // 转换为bits
              const speedMbps = (bitsLoaded / duration / (1024 * 1024)).toFixed(2);
              resolve(speedMbps);
            } else {
              reject();
            }
          }
        };
        xhr.send();
      });
    },
    // 浏览器检测
    testBrowser() {
      const ua = navigator.userAgent;
      let browserName;
      let version;
      if (ua.includes('Edg/')) { //Edge
        browserName = 'Microsoft Edge';
        version = ua.match(/Edg\/([\d.]+)/)[1];
      } else if (ua.includes('Chrome')) { // Google
        browserName = 'Google Chrome';
        version = ua.match(/Chrome\/([\d.]+)/)[1];
      } else if (ua.includes('Firefox')) { //Firefox
        browserName = 'Mozilla Firefox';
        version = ua.match(/Firefox\/([\d.]+)/)[1];
      } else if (ua.includes('Safari')) { // 苹果
        browserName = 'Apple Safari';
        version = ua.match(/Version\/([\d.]+)/)[1];
      } else if (ua.includes('Trident')) { // IE
        browserName = 'Internet Explorer';
        version = ua.match(/rv:([\d.]+)/)[1];
      } else {
        browserName = '未知浏览器';
        version = '未知版本';
      }
      return `
    <div class="browser-info">
      <h3>浏览器检测结果：</h3>
      <p>浏览器名称：${browserName}</p>
      <p>版本号：${version}</p>
      ${this.generateBrowserWarning(browserName, version)}
    </div>
  `;
    },
    //浏览器提示信息
    generateBrowserWarning(name, version) {
      const ieWarning = name.includes('Internet Explorer') ?
        '<p class="warning">⚠️ 检测到您正在使用IE浏览器，建议升级到最新版Edge浏览器</p>' : '';
      const chromeWarning = !name.includes('Chrome') ?
          '<p class="warning">⚠️ 推荐您使用Chrome浏览器</p> <br> <a target="_blank" href="https://www.google.cn/chrome/">点击下载最新Chrome浏览器</a>\'' : '';
      const versionWarning = name.includes('Chrome') && parseFloat(version) < 135  ?
        '<p class="warning">⚠️ 检测到您的谷歌浏览器版本较旧，建议升级到最新版本</p><br> <a target="_blank" href="https://www.google.cn/chrome/">点击下载最新Chrome浏览器</a>' : '';
      return ieWarning || chromeWarning || versionWarning;
    },
    // 系统检测
    testSystem() {
      const ua = navigator.userAgent;
      const systemInfo = this.detectSystem(ua);

      return `
    <div class="system-info">
      <h3>系统检测结果：</h3>
      <p>操作系统：${systemInfo.os}</p>
      <p>版本号：${systemInfo.version}</p>
      ${this.generateSystemWarning(systemInfo.os, systemInfo.version)}
    </div>
  `;
    },
    // 系统检测
    detectSystem(ua) {
      let os = '未知系统';
      let version = '未知版本';

      // Windows 版本检测
      if (/Windows NT 10.0/i.test(ua)) {
        os = 'Windows';
        version = this.getWindowsVersion(ua) || '10/11';
      } else if (/Windows NT 6.3/i.test(ua)) {
        os = 'Windows';
        version = '8.1';
      } else if (/Windows NT 6.2/i.test(ua)) {
        os = 'Windows';
        version = '8';
      } else if (/Windows NT 6.1/i.test(ua)) {
        os = 'Windows';
        version = '7';
      } else if (/Windows NT 6.0/i.test(ua)) {
        os = 'Windows';
        version = 'Vista';
      } else if (/Windows NT 5.1/i.test(ua)) {
        os = 'Windows';
        version = 'XP';
      }
      // 其他系统检测
      else if (/Macintosh/i.test(ua)) {
        os = 'macOS';
        version = this.getMacOSVersion(ua);
      } else if (/Linux/i.test(ua)) {
        os = 'Linux';
        version = this.getLinuxDistribution(ua);
      } else if (/Android/i.test(ua)) {
        os = 'Android';
        version = this.getAndroidVersion(ua);
      } else if (/iPhone|iPad|iPod/i.test(ua)) {
        os = 'iOS';
        version = this.getiOSVersion(ua);
      }

      return { os, version };
    },

    // Windows 详细版本识别
    getWindowsVersion(ua) {
      const buildNumberMatch = ua.match(/Windows NT 10\.0; Win64; x64(?:; ([\d.]+))?/);
      if (buildNumberMatch && buildNumberMatch[1]) {
        const build = parseInt(buildNumberMatch[1]);
        if (build >= 22000) return '11';
        if (build >= 19043) return '10 21H2';
        if (build >= 19041) return '10 20H2';
      }
      return '10';
    },

    // 生成系统警告
    generateSystemWarning(os, version) {
      const warnings = [];

      // Windows 警告
      if (os === 'Windows') {
        const verNum = parseFloat(version);
        if (verNum < 10) {
          warnings.push('⚠️ 检测到旧版Windows系统，建议升级到Windows 10/11以获得更好支持');
        }

        if (version.includes('11')) {
          warnings.push('✅ 您正在使用最新的Windows 11系统');
        }
      }

      // macOS 警告
      if (os === 'macOS' && parseFloat(version) < 12) {
        warnings.push('⚠️ 检测到较旧的macOS版本，建议升级到Monterey或更高版本');
      }

      return warnings.length > 0
        ? `<div class="warnings">${warnings.join('<br>')}</div>`
        : '';
    }
  },
};
</script>
<style scoped>

.detection-btns {
    margin-bottom: 20px;
    text-align: left;
}

.detection-content {
    min-height: 300px;
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
}
</style>